module.exports = {"id":"9676","name":"Samuel Eto'o","rating":"81","photo":"./data/images/photos/2/9676.png","club":{"name":"Konyaspor","logo":"./data/images/clubs/Konyaspor.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamuelEto'o0.json
// module id = 3807
// module chunks = 0